export default {
  methods: {
    convertToHTML(data, prepend) {
      let html = "";
      let firstParagraph = true;

      if (Array.isArray(data)) {
        data.forEach((item) => {
          switch (item.type) {
            case "heading":
              if (item.children && item.children[0] && item.children[0].text) {
                html += `<h${item.level} role="heading" aria-level="${item.level}">`;

                item.children.forEach((c) => {
                  if (c.bold) {
                    html += `<b>${c.text}</b>`;
                  } else if (c.underline) {
                    html += `<u>${c.text}</u>`;
                  } else if (c.italic) {
                    html += `<i>${c.text}</i>`;
                  } else {
                    html += `${c.text}`;
                  }
                });
                html += `</h${item.level}>`;
              }
              break;
              case "paragraph":
                if (item.children && item.children[0] && item.children[0].text) {
                  html += `<p>`;
                  if (firstParagraph && prepend != undefined) {
                    html += `<b>${prepend}</b>`;
                    firstParagraph = false;
                  }
                  item.children.forEach((c) => {
                    if (c.type == "text") {
                      let processedText = c.text.replace(/\n/g, "<br>"); // \n durch <br> ersetzen
                      if (c.bold) {
                        html += `<b>${processedText}</b>`;
                      } else if (c.underline) {
                        html += `<u>${processedText}</u>`;
                      } else if (c.italic) {
                        html += `<i>${processedText}</i>`;
                      } else {
                        html += `${processedText}`;
                      }
                    } else if (c.type == "link") {
                      html += `<a href="${c.url}">${c.children[0].text.replace(/\n/g, "<br>")}</a>`;
                    }
                  });
                  html += `</p>`;
                }
                break;
            case "list":
              if (Array.isArray(item.children)) {
                let op = "ul";
                if (item.format == "ordered") {
                  op = "ol";
                }
                html += `<${op}>`;
                item.children.forEach((listItem) => {
                  if (
                    listItem.children &&
                    listItem.children[0] &&
                    listItem.children[0].text
                  ) {
                    html += `<li><span>`;
                    listItem.children.forEach((c) => {
                      if (c.bold) {
                        html += `<b>${c.text}</b>`;
                      } else if (c.underline) {
                        html += `<u>${c.text}</u>`;
                      } else if (c.italic) {
                        html += `<i>${c.text}</i>`;
                      } else {
                        html += `${c.text}`;
                      }
                    });
                    html += `</span></li>`;
                  }
                });
                html += `</${op}>`;
              }
              break;
            default:
              break;
          }
        });
      }

      return html;
    },
  },
};
